import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'deferredTime' })
export class DeferredTimePipe implements PipeTransform {

  public transform(duration: number) {
    const hour = Math.floor(duration / 60);
    const min = duration % 60;
    const minPluralText = min > 1 ? $localize`Minutes` : $localize`Minute`;
    const hoursPluralText = hour > 1 ? $localize`Hours` : $localize`Hour`;

    const transformMinutes = () => {
      return min > 0 ? `${min} ${minPluralText}` : '';
    };

    const transformHours = () => {
      return `${hour} ${hoursPluralText}`;
    };

    if (hour <= 0) {
      return transformMinutes();
    }

    return `${transformHours()} ${transformMinutes()}`;
  }
}
